export const searchFolderName = "dTuXMc";
export default {searchFolderName};